import React from 'react'

import WebhookBoletoFormPageContainer from './WebhookBoletoFormPageContainer'

export class WebhookBoletoFormPage extends React.Component {
  render() {
    return <WebhookBoletoFormPageContainer {...this.props} />
  }
}

